import React, { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';

const TINYMCE_API_KEY = process.env.REACT_APP_TINYMCE_API_KEY;

const RichTextEditor = ({ label, value, onChange, placeholder, height = 250 }) => {
  const editorRef = useRef(null);

  return (
    <div className="rich-text-editor">
      {label && (
        <label className="block text-sm font-medium text-dark-700 mb-1.5">
          {label}
        </label>
      )}
      <Editor
        apiKey={TINYMCE_API_KEY}
        onInit={(evt, editor) => { editorRef.current = editor; }}
        value={value}
        onEditorChange={(content) => onChange(content)}
        init={{
          height,
          menubar: false,
          branding: false,
          promotion: false,
          plugins: 'lists link table code autolink charmap visualblocks wordcount',
          toolbar: 'bold italic underline strikethrough | bullist numlist | h2 h3 | table | link charmap | code removeformat',
          content_style: 'body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; font-size: 14px; padding: 4px 8px; }',
          placeholder: placeholder || 'Start writing...',
          statusbar: false,
          resize: false,
          block_formats: 'Paragraph=p; Heading 2=h2; Heading 3=h3',
          skin: 'oxide',
          content_css: 'default',
        }}
      />
    </div>
  );
};

export default RichTextEditor;
